import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useBrandGroupProvider from '@hooks/useBrandGroupProvider'
import useBrandGroupProviders from '@hooks/useBrandGroupProviders'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import type { BrandGroupProviderModel } from '@models/types'

import BrandGroupProviderListItem from './BrandGroupProviderListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Provider Title',
    },
  ]
}

const BrandGroupProviders = (props: { brandGroupId: number}) => {
  const { brandGroupId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const brandGroupProvidersPayload = useBrandGroupProviders({
    filters: {
      brand_group_id: brandGroupId,
      ...pageFilters,
    },
    performHttpRequests: !!brandGroupId,
    requestOptions: { include_provider_details: true },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandGroupProviders,
    filteredBrandGroupProvidersCount,
    hasFilteredBrandGroupProviders,
    loading,
  } = brandGroupProvidersPayload

  const {
    callbacks: { addBrandGroupProvider },
  } = useBrandGroupProvider({ brand_group_id: brandGroupId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={hasFilteredBrandGroupProviders && <DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Providers"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && !hasFilteredBrandGroupProviders && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Providers present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or add a Provider.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredBrandGroupProviders && (
      // @ts-expect-error TS2322
      <DashboardModule.ScrollableSection flexDirection="column">
        {filteredBrandGroupProviders.map((brandGroupProvider: BrandGroupProviderModel) => (
          <BrandGroupProviderListItem
            key={brandGroupProvider.id}
            brandGroupProvider={brandGroupProvider}
          />
        ))}
      </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredBrandGroupProvidersCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addBrandGroupProvider()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Provider
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default BrandGroupProviders
